import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "row profilePicture"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "user-main-line"
};
const _hoisted_4 = {
  key: 0,
  class: "separator-dot"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_text_highlight = _resolveComponent("text-highlight");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container", _ctx.containerClassFromContent]),
    style: _normalizeStyle(_ctx.cssVars)
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    alt: "userImage",
    class: _normalizeClass(["userImage", _ctx.size]),
    src: _ctx.userIsInstanceOfUserInfos ? _ctx.user['imgUrl'] : _ctx.user['img']
  }, null, 10, _hoisted_2)]), _createElementVNode("div", {
    class: "row profileData",
    style: _normalizeStyle(_ctx.cssVars)
  }, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_text_highlight, {
    label: _ctx.userIsInstanceOfUserInfos ? _ctx.user['label'] : _ctx.user['firstName'] + ' ' + _ctx.user['lastName'],
    term: _ctx.searchTerm,
    class: "name"
  }, null, 8, ["label", "term"]), _ctx.role !== '' ? (_openBlock(), _createElementBlock("span", _hoisted_4, "∙")) : _createCommentVNode("", true), _ctx.role !== '' ? (_openBlock(), _createBlock(_component_text_highlight, {
    key: 1,
    label: _ctx.role,
    term: _ctx.searchTerm,
    class: "role"
  }, null, 8, ["label", "term"])) : _createCommentVNode("", true)]), _ctx.secondLineContent !== '' ? (_openBlock(), _createBlock(_component_text_highlight, {
    key: 0,
    label: _ctx.secondLineContent,
    term: _ctx.searchTerm,
    class: "email"
  }, null, 8, ["label", "term"])) : _createCommentVNode("", true)], 4)], 6);
}